import React from "react";

import { GenericStudioAdminPanel } from "../../sdk/studio/react";

/**
 * RetailStudioAdminPanel
 *
 * Domain-specific Admin integration of the generic Studio host.
 *
 * The Admin framework does not implement Retail Studio behavior.
 * Generic embedded/fullscreen behavior remains owned by the
 * generic Studio framework.
 */
export default function RetailStudioAdminPanel(props) {
  return (
    <GenericStudioAdminPanel
      {...props}
      className="retail-studio-admin-panel"
    />
  );
}
